<template>
  <div>
    <div class="tree_container">
      <!-- <el-button icon="el-icon-plus" @click="addTopMenu">添加顶部菜单</el-button> -->
      <br />
      <br />
      <br />
      <el-tree
        v-loading="loading"
        :data="menuListData"
        :props="defaultProps"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        :render-content="renderContent"
      ></el-tree>
    </div>

    <!-- 菜单弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showBox">
      <el-form ref="formAdd" :model="form">
        <el-form-item :label="$t('menu.chName')" prop="cn" :label-width="formLabelWidth">
          <el-input v-model="form.cn" auto-complete="off" @input="change($event)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.enName')" prop="en" :label-width="formLabelWidth">
          <el-input v-model="form.en" auto-complete="off" @input="change($event)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.vnName')" prop="vn" :label-width="formLabelWidth">
          <el-input v-model="form.vn" auto-complete="off" @input="change($event)"></el-input>
        </el-form-item>
         <el-form-item v-show="showBtn"  label="授权标识" prop="path" :label-width="formLabelWidth">
          <el-input v-model="form.path" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-show="!showBtn" :label="$t('menu.comPath')" prop="component" :label-width="formLabelWidth">
          <el-input v-model="form.component" auto-complete="off"></el-input>
          <div class="info">组件路径：项目中页面所在目录.例如：sys/permission</div>
          <div class="info">此项目为父子菜单，如需要子菜单，父菜单此项可以为空</div>
        </el-form-item>
        <el-form-item v-show="!showBtn"  :label="$t('menu.pathName')" prop="path" :label-width="formLabelWidth">
          <el-input v-model="form.path" auto-complete="off"></el-input>
          <div class="info">访问路径：最好跟组件路径一致,保持唯一，例如：/sys/permission</div>
          <div class="info">访问路径：当有多级菜单时此项会作为唯一标识展开菜单，所以不能为空，请设置唯一</div>
        </el-form-item>
        <el-form-item v-show="!showBtn"  :label="$t('menu.component')" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" auto-complete="off"></el-input>
           <div class="info">此项目为父子菜单，如需要子菜单，父菜单此项可以为空</div>
        </el-form-item>
        <el-form-item v-show="!showBtn" :label="$t('menu.icon')" prop="meta.icon" :label-width="formLabelWidth">
          <el-col :span="11">
            <el-input v-model="form.meta.icon" auto-complete="off"></el-input>
          </el-col>
          <el-col :span="11">
            <el-button @click="showIconBox = true" style="margin-left:20px;" type="primary" plain>{{$t('menu.choiceIcon')}}</el-button>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('menu.sort')" prop="sort" :label-width="formLabelWidth">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item  label="菜单显示" prop="hidden" :label-width="formLabelWidth" >
          <el-select

            v-model="form.hidden"
            placeholder="菜单显示或隐藏"
          >
            <el-option
              v-for="item in hiddenValues"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showBox = false">{{$t('common.cancle')}}</el-button>
        <el-button type="primary" @click="submitData">{{$t('common.ok')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('menu.choiceIcon')" :visible.sync="showIconBox">
      <el-scrollbar class="icon_box">
        <el-col
          @click.native="choiceIcon(item.name)"
          :span="3"
          v-for="(item,index) in iconList"
          :key="index"
        >
          <svg-icon :icon-class="item.name" />
          <div style="margin-top:20px;">{{item.name}}</div>
        </el-col>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import {
  menuList,
  editMenuList,
  addMenuList,
  delMenuList
} from "@/api/sys/menuList";
import iconListData from "../../assets/icon.json";
export default {
  data() {
    return {
      loading:true,
      menuListData: [],
      showBox: false,
      showIconBox: false,
      hiddenValues: [{
        value: 1,
        label: '显示'
      }, {
        value: 2,
        label: '隐藏'
      }],
      form: {
        cn: "",
        en: "",
        vn: "",
        component: "",
        id: 0,
        level: 0,
        modelId: 0,
        label: "",
        name: "",
        path: "",
        pid: "",
        remark: "",
        sort: 0,
        hidden:'1', //显示
        meta: {
          title: "",
          icon: ""
        }
      },
      iconList: [],
      formLabelWidth: "150px",
      titleName: this.$t("menu.editMenu"),
      changeType: 1, // 是编辑还是新增区分
      showBtn:false,
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  mounted() {
    this.getMenuList();
  },
  created() {
    this.iconList = iconListData.data;
  },
  methods: {
    addTopMenu() {
      this.changeType = 2;
      this.showBox = true;
      this.form.pid = 0;
    },
    getMenuList() {
      menuList().then(res => {
        if (res.code == 0) {
          this.menuListData = res.result;
          this.loading = false
        }
      });
    },
    remove(node, data) {
      const h = this.$createElement;
      this.$msgbox({
        title: this.$t("common.tip"),
        message: h("p", null, [h("span", null, this.$t("common.ifDelete"))]),
        showCancelButton: true,
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancle"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMenuList(data.id).then(res => {
              if (res.code == 0) {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
              }
            });
            done();
          } else {
            done();
          }
        }
      }).then(action => {
        if (action == "confirm") {
          this.$message({
            type: "success",
            message: this.$t("common.conDelete")
          });
        } else {
          this.$message({
            type: "info",
            message: this.$t("common.canceld")
          });
        }
      });
    },
    resetForm(formName) {
      this.$nextTick(() => {
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }
      });
    },
    choiceIcon(name) {
      this.form.meta.icon = name;
      this.showIconBox = false;
    },
    change() {
      this.$forceUpdate();
    },
    edit(data, type) {
      data.path = data.path.split("?")[0];
      //编辑弹框
      this.changeType = type;
      this.showBox = true;
      this.showBtn = false
      if (type == 1) {
        //编辑菜单
        this.titleName = this.$t("menu.editMenu");
        let title = JSON.parse(data.label);
        data.en = title.en_US;
        data.cn = title.zh_CN;
        data.vn = title.vi_VN;
        this.form = data;
        this.form.pid = "";
      } else if(type == 2){
        //新增菜单
        this.titleName = this.$t("menu.addMenu");
        this.form.pid = data.id;
      }else if(type == 3){
        //新增按钮
        this.form.pid = data.id;
        this.showBtn = true
        this.titleName = "添加按钮"
      }else{
        //编辑按钮
        this.showBtn = true
        this.titleName = "编辑按钮"
        let title = JSON.parse(data.label);
        data.en = title.en_US;
        data.cn = title.zh_CN;
        data.vn = title.vi_VN;
        this.form = data;
        this.form.pid = "";
      }
    },
    submitData() {
      let title = {
        zh_CN: this.form.cn,
        en_US: this.form.en,
        vi_VN: this.form.vn
      };
      //提交前统一拼接上 后台识别字段
      if(this.changeType == 1 || this.changeType == 2){
        this.form.path = this.form.path + "?{params}";
      }
      this.form.meta.title = JSON.stringify(title);
      if (this.changeType == 1 || this.changeType == 4) {
        //编辑
        editMenuList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t("common.changeSu"),
              type: "success"
            });
          }
          this.getMenuList();
        });
      } else {

        if(this.changeType == 3){
          //新增按钮
          this.form.type = 2
        }else{
          this.form.type = 1
        }
        addMenuList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t("common.addSu"),
              type: "success"
            });
            this.getMenuList();
          }
        });
      }
      this.showBox = false;
    },
    renderContent(h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex;  align-items: center; justify-content: space-between; font-size: 14px;  padding-right: 8px;">
          <span>
            <span style="vertical-align:middle">

              <svg-icon icon-class={node.data.meta.icon} />
            </span>
            <span style="margin-left:10px;vertical-align:middle">
              {node.data.meta.title}
            </span>
          </span>

          <span v-show={node.data.name != "commonPage"}>
            <el-button
              style="font-size: 12px;"
              type="text"
              v-show={node.data.name != "Layout" && node.data.type != 2}
              v-auth={'sys:permission:editMenu'}
              on-click={() => this.edit(data, 1)}
            >
              {this.$t("common.edit")}
            </el-button>
            <el-button
              style="font-size: 12px;"
              type="text"
              on-click={() => this.edit(data, 2)}
              v-auth={'sys:permission:addMenu'}
              v-show={node.data.type != 2}
            >
              {this.$t("common.add")}
            </el-button>
            <el-button
              style="font-size: 12px;"
              type="text"
              v-show={node.data.name != "Layout" && node.data.type != 2 }
              v-auth={'sys:permission:deleteMenu'}
              on-click={() => this.remove(node, data)}
            >
              {this.$t("common.delete")}
            </el-button>
            <el-button
              style="font-size: 12px;"
              type="text"
              v-auth={'sys:permission:addBtn'}
              v-show={ (node.data.children.length == 0 && node.data.type != 2) ||( node.data.children.length != 0 && node.data.children[0].type == 2) }
              on-click={() => this.edit(data, 3)}
            >
              添加按钮
            </el-button>
             <el-button
              style="font-size: 12px;"
              type="text"
              v-auth={'sys:permission:editBtn'}
              v-show={ node.data.type == 2}
              on-click={() => this.edit(data, 4)}
            >
              编辑按钮
            </el-button>
             <el-button
              style="font-size: 12px;"
              type="text"
              v-auth={'sys:permission:deleteBtn'}
              v-show={ node.data.type == 2}
              on-click={() => this.remove(node, data)}
            >
              删除按钮
            </el-button>
          </span>
        </span>
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.tree_container {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
.tree_container:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.icon_box .el-col {
  text-align: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
}
.icon_box .el-col:hover {
  background: #409eff2b;
}
.info {
  font-size: 12px;
  color: #999;
  line-height: 16px;
}
</style>
